import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@src/design-system/command';
import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import { useTableStates } from '@src/design-system/molecules/ticlick-table/hooks/use-table-states';
import { OPERATORS_ACC_TO_FILTER_TYPE } from '@shared/features/views/components/entities-filters/config';

import type { TCustomField } from '@shared/types/custom-field';
import leadApi from '@features/leads/services/lead-api';

export function DynamicCustomFieldFilterDropdown({ index }: { index: number }) {
  const { data } = leadApi.useFetch();
  const customFields = data?.results[0].custom_fields;

  const { updateCustomFieldFilter } = useTableViewHelpers();
  const { tableFilters } = useTableStates();
  const dynamicFilters = tableFilters?.customFieldFilters || [];

  const filterAlreadySelected = (q: TCustomField) =>
    !dynamicFilters.map((df) => df?.custom_field?.id).includes(q?.id);

  const onClickQuestion = (question: TCustomField, index: number) => {
    updateCustomFieldFilter(
      {
        custom_field: question as unknown as TCustomField,
        operator: OPERATORS_ACC_TO_FILTER_TYPE[question.type][0],
        value: [],
      },
      index
    );
  };

  return (
    <Command>
      <CommandInput
        className='max-h-[32px]'
        placeholder='Search by name...'
      />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup>
          {customFields?.filter(filterAlreadySelected).map((cf) => (
            <CommandItem
              key={cf.id}
              value={`${cf.label}-${cf.id}`}
              onSelect={() => onClickQuestion(cf, index)}
              className='p-1'
            >
              {cf.label}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
